import { Component, OnInit } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import * as SimpleMDE from 'simplemde';
import { ObjectObservable } from '../../shared/base/object-observable';
import { MESSAGE_COMMON_ERROR } from '../../shared/message';
import { Lesson } from '../shared/lesson';
import { LessonAttachment } from '../shared/lesson-attachment';
import { LessonAttachmentService } from '../shared/lesson-attachment.service';
import { MESSAGE_ADD_ATTACHMENT_SUCCESS } from '../shared/lesson-message';
import { APPCONFIG } from "../../config";

@Component({
  selector: 'app-lesson-edit',
  templateUrl: './lesson-edit.component.html',
  styleUrls: ['./lesson-edit.component.scss']
})
export class LessonEditComponent implements OnInit {

  lessonObservable: ObjectObservable<Lesson>;
  attachment: LessonAttachment;
  isDragOver: boolean;
  isUploaded = true;
  private simplemde: SimpleMDE;
  private AppConfig: any;

  constructor(private snackBar: MatSnackBar,
              private route: ActivatedRoute,
              private service: LessonAttachmentService) {
  }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
    this.route.parent.data.subscribe((data: {lesson: ObjectObservable<Lesson>}) => this.lessonObservable = data.lesson);
  }

  async onSubmit(value: Lesson) {
    try {
      delete value.$exists;
      delete value.$key;
      await this.lessonObservable.update(value);
    } catch (e) {
      this.handleError(e);
    }
  }

  private handleError(error: any) {
    this.openSnackBar(MESSAGE_COMMON_ERROR);
  }

  private openSnackBar(message) {
    const config = new MatSnackBarConfig();
    config.duration = 3000;
    this.snackBar.open(message, null, config);
  }

  onFileOver(isOver: boolean) {
    this.isDragOver = isOver;
  }

  getSimpleMDE(simpleMDE: SimpleMDE) {
    this.simplemde = simpleMDE;
  }

  async onFileDrop(file: File) {
    this.isUploaded = this.isDragOver;

    const pos = this.simplemde.codemirror.getCursor();
    this.simplemde.codemirror.setSelection(pos, pos);

    try {
      this.attachment = await this.service.upload(this.lessonObservable.$ref.key, file);
      const url = `![${this.attachment.name}](${this.attachment.downloadURL})`;
      this.simplemde.codemirror.replaceSelection(url);
      this.isUploaded = true;
      this.openSnackBar(MESSAGE_ADD_ATTACHMENT_SUCCESS);
    } catch (e) {
      this.handleError(e);
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/lesson-edit/lesson-edit.component.ts